export const transactionTypes = {
  OFFER_TRANSACTION: 'ot',
  SECURITY_TRADE: 'st',
  MONEY_TRANSACTION: 'mt',
  OTHERS: 'x',
};

export const historyFilteringOptions = [
  {
    label: 'Offer Transactions',
    code: transactionTypes.OFFER_TRANSACTION,
  },
  {
    label: 'Security Trades',
    code: transactionTypes.SECURITY_TRADE,
  },
  {
    label: 'Money Transactions',
    code: transactionTypes.MONEY_TRANSACTION,
  },
  {
    label: 'Other',
    code: transactionTypes.OTHERS,
  },
];

export const historyTransactionByCategories = [
  {
    category: 'Deposits',
    type: transactionTypes.MONEY_TRANSACTION,
  },
  {
    category: 'Withdrawals',
    type: transactionTypes.MONEY_TRANSACTION,
  },
  {
    category: 'Internal Transfers',
    type: transactionTypes.OTHERS,
  },
  {
    category: 'Trades',
    type: transactionTypes.SECURITY_TRADE,
  },
  {
    category: 'Distributions',
    type: transactionTypes.OTHERS,
  },
  {
    category: 'Corporate Actions',
    type: transactionTypes.OTHERS,
  },
  {
    category: 'Sweep',
    type: transactionTypes.OTHERS,
  },
];

export const filterTypeOptsByTransactionTypes = [
  {
    type: transactionTypes.MONEY_TRANSACTION,
    filter: 'ACH Deposit',
  },
  {
    type: transactionTypes.MONEY_TRANSACTION,
    filter: 'ACH Withdrawal',
  },
  {
    type: transactionTypes.MONEY_TRANSACTION,
    filter: 'Client Deposits',
  },
  {
    type: transactionTypes.OFFER_TRANSACTION,
    filter: 'Offer Order',
  },
  {
    type: transactionTypes.OFFER_TRANSACTION,
    filter: '(Conditional) Offer Order',
  },
  {
    type: transactionTypes.SECURITY_TRADE,
    filter: 'Security Order (Buy)',
  },
  {
    type: transactionTypes.SECURITY_TRADE,
    filter: 'Security Order (Sell)',
  },
];

export default {
  historyFilteringOptions,
};



// WEBPACK FOOTER //
// ./src/components/History/lookups.js